import { render } from "./ProjectData.vue?vue&type=template&id=fb599c72&scoped=true&ts=true"
import script from "./ProjectData.ts?vue&type=script&lang=ts"
export * from "./ProjectData.ts?vue&type=script&lang=ts"

import "./ProjectData.vue?vue&type=style&index=0&id=fb599c72&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb599c72"]])

export default __exports__